import { SafeHtml } from '@angular/platform-browser';

export class Modal {
    title?: string;
    body: SafeHtml | string;

    constructor(config: {title?: string; body?: SafeHtml | string}) {
        if (config.body) {
            this.title = config.title;
        }
        this.body = config.body || config.title;
    }
}
